import React from 'react';

import styles from './styles.module.scss';

import { ListOnRoveLandingType } from '@utils/types/landings';
import ImageWithLoader from '@components/_shared/imageWithLoader';
import { splitByCommas } from '@utils/helpers';
import {
  AverageBookingValue,
  AverageRating,
  NightsBooked,
  NYCOccupancy,
} from '@assets/icons/list-on-rove';

const ListOnRoveOutperformance = (
  props: ListOnRoveLandingType['outperformance']
) => {
  const {
    title,
    description,
    nightsBooked,
    nycOccupancy,
    averageRating,
    averageBookingValue,
  } = props;

  return (
    <div className={styles.outperformance}>
      <div className={styles.outperformance__wrapper}>
        <div>
          <h4 className={styles.outperformance__title}>{title}</h4>
          <p className={styles.outperformance__description}>{description}</p>
        </div>

        <ImageWithLoader
          layout="fill"
          src="/images/outperformance-chart.png"
          alt={title}
          objectFit="cover"
          containerStyle={styles.outperformance__chart}
        />
      </div>

      <div className={styles.items}>
        <div className={styles.item}>
          <NightsBooked />
          <div>
            <div className={styles.item__value}>
              {splitByCommas(nightsBooked)}+
            </div>
            <div className={styles.item__label}>Nights Booked</div>
          </div>
        </div>

        <div className={styles.item}>
          <NYCOccupancy />
          <div>
            <div className={styles.item__value}>{nycOccupancy}%</div>
            <div className={styles.item__label}>NYC Occupancy</div>
          </div>
        </div>

        <div className={styles.item}>
          <AverageRating />
          <div>
            <div className={styles.item__value}>{averageRating}</div>
            <div className={styles.item__label}>Average Rating</div>
          </div>
        </div>

        <div className={styles.item}>
          <AverageBookingValue />
          <div>
            <div className={styles.item__value}>{averageBookingValue}x</div>
            <div className={styles.item__label}>
              Avg. Booking Value v. Airbnb
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListOnRoveOutperformance;
